export enum OrderType {
  ORDER = "ORDER",
  CST_ORDER = "CST_ORDER",
}
